export default __webpack_public_path__ + "static/media/recycle.99bc2e89.jpg";